import type { WebWidgetData, WebLegacyWidgetEntity } from '@web/types';
import { type JssStyle } from 'jss';

import { Directive, inject } from '@angular/core';
import { type Observable } from 'rxjs';

import { type Uuid } from '@common/types';

import { SpBaseViewComponent } from '@common/abstract/sp-base-view.component';
import { WidgetsFacade } from '@web/store/page-structure/widgets/widgets.facade';
import { LayoutFacade } from '@web/store/layout/layout.facade';
import { HistoryFacade } from '@web/store/history/history.facade';

@Directive()
export abstract class WebBaseViewComponent<T extends WebWidgetData> extends SpBaseViewComponent<
    T,
    WebLegacyWidgetEntity<T>
> {
    protected readonly widgetsFacade: WidgetsFacade = inject(WidgetsFacade);
    protected readonly layoutFacade: LayoutFacade = inject(LayoutFacade);
    protected readonly historyFacade: HistoryFacade = inject(HistoryFacade);

    public readonly isDeviceMobile$: Observable<boolean> = this.layoutFacade.isDeviceMobile$;
    public readonly isDeviceTablet$: Observable<boolean> = this.layoutFacade.isDeviceTablet$;
    public readonly isDeviceDesktop$: Observable<boolean> = this.layoutFacade.isDeviceDesktop$;
    public readonly selectedEntityId$: Observable<Uuid> = this.layoutFacade.entityId$;

    protected updateWidgetData(data: Partial<T>): void {
        this.historyFacade.addWidgetUpdateChangeToHistory(
            {
                id: this.widget.id,
                changes: { data: this.widget.data },
            },
            {
                id: this.widget.id,
                changes: { data },
            }
        );
        this.widgetsFacade.updateWidgetData(this.widget.id, data);
    }

    protected updateWidgetStyles(styles: JssStyle): void {
        this.historyFacade.addWidgetUpdateChangeToHistory(
            {
                id: this.widget.id,
                changes: { styles: this.widget.styles },
            },
            {
                id: this.widget.id,
                changes: { styles },
            }
        );
        this.widgetsFacade.updateWidgetStyles(this.widget.id, styles);
    }

    protected get getWidgetId(): string {
        return this.widget?.displayId ? this.widget.displayId : `widget-${this.widget?.id}`;
    }
}
